const DEFAULT_DOMAIN = 'outlook.office.com';
import { getApplicationSettings } from 'owa-application-settings';
import { isFeatureEnabled } from 'owa-feature-flags';

const replaceDomain = (url: string, newDomain: string) => {
    const originalUrl = new URL(url);
    originalUrl.hostname = newDomain;
    return originalUrl.toString();
};

const getDomainURL = () => {
    if (isFeatureEnabled('bookings-fixBookingCustomDomain')) {
        const domainURL = new URL(getApplicationSettings('BookingsDomainConfig').domainURL);
        return domainURL.hostname;
    } else {
        const currentDomain = `${window.location.hostname}` || DEFAULT_DOMAIN;
        return currentDomain;
    }
};

const fixBookingUrlDomain = (bookingUrl: string) => {
    const newDomain = getDomainURL();
    return replaceDomain(bookingUrl, newDomain);
};

export default fixBookingUrlDomain;
